import createReactComponent from '../createReactComponent';
export default createReactComponent('rainbow', 'IconRainbow', [
  [
    'path',
    { d: 'M22 17c0 -5.523 -4.477 -10 -10 -10s-10 4.477 -10 10', key: 'svg-0' },
  ],
  ['path', { d: 'M18 17a6 6 0 1 0 -12 0', key: 'svg-1' }],
  ['path', { d: 'M14 17a2 2 0 1 0 -4 0', key: 'svg-2' }],
]);
